/** Trust score of 0 means unavailable; hide trust score UI in that case. */
function shouldShowEntitlementTrustScore(
  trustScore: number | null | undefined
): boolean {
  return Number(trustScore) > 0;
}

export default shouldShowEntitlementTrustScore;
